<template>
  <h2 :class="prefixCls" class="mb-10 text-2xl font-semibold text-center enter-x xl:text-left">
    {{ getFormTitle }}
  </h2>
</template>
<script lang="ts" setup>
  import { computed, unref } from 'vue';
  import { useI18n } from '@mcex/locale';
  import { LoginStateEnum, useLoginState } from './useLogin';
  import { useDesign } from '/@/hooks/web/useDesign';

  const { t } = useI18n();
  const { prefixCls } = useDesign('login-form-title');

  const { getLoginState } = useLoginState();

  const getFormTitle = computed(() => {
    const titleObj = {
      [LoginStateEnum.CHECK_ACCOUNT_BEFORE_LOGIN]: t('sys.login.signInFormTitle'),
      [LoginStateEnum.RESET_PASSWORD]: t('sys.login.forgetFormTitle'),
      [LoginStateEnum.LOGIN]: t('sys.login.signInFormTitle'),
      [LoginStateEnum.REGISTER]: t('sys.login.signUpFormTitle'),
      [LoginStateEnum.MOBILE]: t('sys.login.mobileSignInFormTitle'),
    };
    return titleObj[unref(getLoginState)];
  });
</script>
<style lang="less">
  @prefix-cls: ~'@{namespace}-login-form-title';
  .@{prefix-cls} {
    color: @text-color-base;
  }
</style>
